export default __webpack_public_path__ + "static/media/fa-regular-400.62a07ffe.eot";